import { ThemeTokens } from '@acp/core-ui';
import { useNavLink } from '@acp/feature/auth';
import { Flex, Text } from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';

export type NavigationItemProps = {
    to?: string;
    label: string;
    isExternal?: boolean;
    onClick?: () => void;
};

export function NavigationItem({
    to,
    label,
    isExternal = false,
    onClick,
}: NavigationItemProps) {
    const href = useNavLink({ to, isExternal });
    let location = useLocation();

    return (
        <Flex
            as={onClick === undefined ? Link : undefined}
            to={href ?? ''}
            onClick={onClick}
            position="relative"
            alignItems="center"
            _hover={{
                _before: {
                    content: '""',
                    h: '2px',
                    position: 'absolute',
                    w: '100%',
                    bgColor: ThemeTokens.AppNavigation.accentColor,
                    bottom: 0,
                    transition: 'all',
                },
            }}
            transition="normal"
            transitionDuration="200ms"
            userSelect="none"
            h="100%"
            px={0}
            boxSizing="initial"
            _before={
                location.pathname === to ? ({
                    content: '""',
                    h: '2px',
                    position: 'absolute',
                    w: '100%',
                    bgColor: ThemeTokens.AppNavigation.accentColor,
                    bottom: 0,
                }) : {}
            }
        >
            <Text
                fontSize="sm"
                fontWeight="bold"
                lineHeight="normal"
                _active={{ color: 'inherit' }}
            >
                {label}
            </Text>
        </Flex>
    );
}
